import { modifyContributorFields, getContributorData } from "../../../../../../../../../store/Users/actions";
import { validateCuit, inputFilled } from "../../../../functions";

export const getContribData = (items) => {
  return [
    {
      text: "CUIT/CUIL",
      name: "cuit",
      value: items?.cuit,
      onBlur: getContributorData,
      onChange: modifyContributorFields,
      checked: validateCuit(items?.cuit),
      errorMessage: validateCuit(items?.cuit) ? "" : "Error Cuit/Cuil inválido",
    },
    {
      text: "(*) Apellido Nombre / Razón Social",
      name: "name",
      value: items?.name,
      onChange: modifyContributorFields,
      checked: inputFilled(items?.name),
      errorMessage: inputFilled(items?.name) ? "" : "Este campo no puede estar vacío",
    },
    {
      text: "(*) Domicilo",
      name: "address",
      value: items?.address,
      onChange: modifyContributorFields,
      checked: inputFilled(items?.address),
      errorMessage: inputFilled(items?.address) ? "" : "Este campo no puede estar vacío",
    },
  ];
};
